import moment from 'moment-timezone';
export function formatDateWithTimeZone(date) {
  let formatStr = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'PP';
  let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  let initialMoment = null;
  const lang = options.lang || 'es';
  const timeZone = options.timeZone || 'Europe/Madrid';
  if (typeof date === 'object') {
    initialMoment = moment(date);
  } else {
    initialMoment = moment.unix(date);
  }
  if (typeof formatStr !== 'string') {
    throw new RangeError('The second argument must of string type.');
  }
  return initialMoment.tz(timeZone).locale(lang).format(formatStr);
}